// import './App.css';
import LoginForm from './pages/login';

function App() {
  return (
    <div className="App">
      <div className="content">
        <LoginForm />
      </div>
    </div>
  );
}

export default App;
